import { Component, ElementRef, OnInit, Optional, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { FeedbackData, Rating } from '@root/app.interfaces';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { STORAGE_NAMES } from '@root/app.config';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { PassDataService } from '@core/services/pass-data/pass-data.service';
import { ServerDataService } from '@core/services/server-data/server-data.service';

@Component({
	selector: 'app-feedback-form',
	templateUrl: './feedback-form.component.html',
	styleUrls: ['./feedback-form.component.scss', './feedback-form.responsive.scss'],
})
export class FeedbackFormComponent implements OnInit {
	static readonly ID = crypto.randomUUID();

	@ViewChild('textAreaElement') textAreaElement: ElementRef<HTMLElement>;

	loading: boolean;
	feedbackSent: boolean;
	feedbackStatus: boolean;
	feedbackModalStatus: boolean;
	ratings: Rating[] = [
		{ score: 1, id: 'bad' },
		{ score: 2, id: 'not_good' },
		{ score: 3, id: 'ok' },
		{ score: 4, id: 'good' },
		{ score: 5, id: 'great' },
	];
	form = this.fb.group({
		feedback: null,
		rating: [null, [Validators.required]],
	});

	get f() {
		return this.form.controls;
	}

	constructor(
		@Optional() public dialogRef: MatDialogRef<FeedbackFormComponent>,
		private fb: UntypedFormBuilder,
		public passDataService: PassDataService,
		private serverDataService: ServerDataService,
		private sessionStorageService: SessionStorageService,
	) {}

	ngOnInit() {
		this.feedbackStatus = this.passDataService.isFeedbackStatus;
		this.feedbackModalStatus = this.dialogRef?.componentRef.componentType.name === FeedbackFormComponent.name;
	}

	onSubmit() {
		if (this.form.invalid) {
			this.textAreaElement.nativeElement.focus();
			return;
		}

		const data: FeedbackData = {
			session_key: this.sessionStorageService.getSession(STORAGE_NAMES.zip_blind_config).session_key,
			rating: this.f.rating.value.score,
			feedback: this.f.feedback.value,
		};

		this.loading = true;
		this.serverDataService.PostFeedbackData(data).subscribe(() => {
			this.loading = false;
			this.feedbackSent = true;
			this.passDataService.isFeedbackStatus = true;
			this.sessionStorageService.setSession(true, STORAGE_NAMES.zip_feedback_status);
		});
	}

	onRating(rating: Rating) {
		this.form.controls.rating.setValue(rating);
	}

	onClose(): void {
		this.dialogRef.close();
	}
}
